export const fetchRoutes = (
    request: woosmap.map.DirectionRequest,
    DirectionsService: woosmap.map.DirectionsService
): Promise<woosmap.map.DirectionResult> =>
    new Promise((resolve, reject) =>
        DirectionsService.route(request, (result, status) => {
            if (status === "OK") {
                resolve(result);
            } else {
                reject({
                    status: status,
                    error_message: result.error_message
                });
            }
        })
    );
